import { AuthXInterceptor } from '../Config/AuthXInterceptor'
import { AxiosInterceptor } from '../../Config/AxiosInterceptor'

AxiosInterceptor()

// const BASE_URL = process.env.REACT_APP_BX_BASE_URL || ''
// const token = process.env.REACT_APP_BX_TOKEN || ''

export const orderBXService = {
  async list(params: {
    page?: number
    limit?: number
    sortOrder?: string
    search?: string
    status?: string
    paymentStatus?: string
    product?: string
    userResourceId?: string
    stationId?: string | undefined
    startDateYYYY_MM_DD?: string
    endDateYYYY_MM_DD?: string
  }) {
    const queryParams: Record<string, any> = {}

    // only append if value exists
    if (params.page !== undefined) {
      queryParams.page = params.page
    }

    if (params.limit !== undefined) {
      queryParams.limit = params.limit
    }

    if (params.sortOrder) {
      queryParams.sortOrder = params.sortOrder
    }

    if (params.search) {
      queryParams.search = params.search
    }

    if (params.status) {
      queryParams.status = params.status
    }

    if (params.paymentStatus) {
      queryParams.paymentStatus = params.paymentStatus
    }

    if (params.product) {
      queryParams.product = params.product
    }

    if (params.userResourceId) {
      queryParams.userResourceId = params.userResourceId
    }

    if (params.stationId && params.stationId !== 'All') {
      queryParams.stationId = params.stationId
    }

    if (params['startDateYYYY_MM_DD']) {
      queryParams['startDateYYYY_MM_DD'] = params['startDateYYYY_MM_DD']
    }

    if (params['endDateYYYY_MM_DD']) {
      queryParams['endDateYYYY_MM_DD'] = params['endDateYYYY_MM_DD']
    }

    return await AuthXInterceptor.get('orders', {
      params: queryParams,
      headers: {
        accept: 'application/json',
      },
    })
  },

  async getById(orderId: string) {
    return await AuthXInterceptor.get(`orders/${orderId}`, {
      headers: { accept: 'application/json' },
    })
  },

  async cancel(orderId: string) {
    return await AuthXInterceptor.post(`orders/${encodeURIComponent(orderId)}/cancel`, undefined, {
      headers: { accept: 'application/json' },
    })
  },

  async ordersSummary(params: {
    status?: string
    paymentStatus?: string
    product?: string
    userResourceId?: string
    stationId?: string | undefined
    startDateYYYY_MM_DD?: string
    endDateYYYY_MM_DD?: string
  }) {
    const queryParams: Record<string, any> = {}

    if (params.status) queryParams.status = params.status
    if (params.paymentStatus) queryParams.paymentStatus = params.paymentStatus
    if (params.product) queryParams.product = params.product
    if (params.userResourceId) queryParams.userResourceId = params.userResourceId
    if (params.stationId) queryParams.stationId = params.stationId

    if (params['startDateYYYY_MM_DD']) {
      queryParams['startDateYYYY_MM_DD'] = params['startDateYYYY_MM_DD']
    }
    if (params['endDateYYYY_MM_DD']) {
      queryParams['endDateYYYY_MM_DD'] = params['endDateYYYY_MM_DD']
    }

    return await AuthXInterceptor.get('orders/summary', {
      params: queryParams,
      headers: {
        accept: 'application/json',
      },
    })
  },

  async csvExport(params?: any) {
    return await AuthXInterceptor.get('orders/csv', {
      params,
      responseType: 'blob',
    })
  },
}
